/**
 * Created by Bart Decorte
 * Date: 05/01/2021
 * Time: 16:57
 */
import Page from '../pages/Page';

export default class ToolsIndex extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/tools/ToolsIndex.js